import { render } from "./report-edit.vue?vue&type=template&id=58906a7e&scoped=true"
import script from "./report-edit.vue?vue&type=script&lang=js"
export * from "./report-edit.vue?vue&type=script&lang=js"

import "./report-edit.vue?vue&type=style&index=0&id=58906a7e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58906a7e"]])

export default __exports__